import { connect } from 'react-redux';
import { setAllCookiesAccepted } from '../../publicSession/actions';
import { showCookieSettingsPopup } from '../../Modals/redux/actionCreators';
const mapDispatchToProps = {
    onAccept: setAllCookiesAccepted,
    onManageInfo: showCookieSettingsPopup
};
export default connect(null, mapDispatchToProps);
